var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useThemeStyle } from '../hooks/useThemeStyle';
export var ListItem = createOverridableComponent('div', function (props, Wrapper, ref) {
    var css = useThemeStyle('listItem', {
        px: 2,
        py: 3,
        bg: 'white',
        borderStyle: 'solid',
        borderColor: 'grey',
        borderWidth: 1,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
    });
    return jsx(Wrapper, __assign({}, props, { ref: ref, css: css }));
});
//# sourceMappingURL=ListItem.js.map